<template>
  <div
    class="modal"
    tabindex="-1"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
          >
            Edit Process
          </h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>

        <div class="modal-body">
          <process-form
            :sections="sections"
            :entity="process"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ProcessForm } from '../../../forms';

export default {
  name: 'EditProcessModal',
  components: { ProcessForm },
  props: {
    sections: {
      type: Array,
      default: () => []
    },
    process: {
      type: Object,
      default: () => null
    }
  }
};
</script>
